import { Button, Image, Link as PopLink } from "@heroui/react";

export default function Header() {
  return (
    <header className="dark:bg-stone-950 bg-transparent absolute lg:text-white z-30 w-screen font-['suse']">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <div
          className="relative flex h-14 items-center
							justify-between gap-3 rounded-2xl
							px-3 before:pointer-events-none
							before:absolute before:inset-0 before:rounded-[inherit]
							before:border before:border-transparent
							before:[background:linear-gradient(to_right,theme(colors.gray.800),
							theme(colors.gray.700),
							theme(colors.gray.800))_border-box]
							 before:[mask-composite:exclude_!important]
							 before:[mask:linear-gradient(white_0_0)_padding-box,_linear-gradient(white_0_0)]
							 after:absolute after:inset-0 after:-z-10
							 after:backdrop-blur-sm"
        >
          {/* Site branding */}
          <div className="flex flex-1 items-center gap-4">
            <Image
              alt="logo"
              className="select-none  (max-width: 640px) 20px, (max-width: 1280px) 20px, 20px"
              height="100"
              src="/SGE2.png"
              width={"100"}
            />
          </div>

          {/* Desktop sign in links */}
          <ul className="flex flex-1 items-center justify-end gap-3">
            <li>
              <Button
                as={PopLink}
                className="btn-sm relative lg:text-black"
                color={"default"}
                href="/login"
                size={"sm"}
                variant={"faded"}
              >
                Sign In
              </Button>
            </li>
            <li>
              <Button
                as={PopLink}
                color={"secondary"}
                className="btn-sm relative lg:bg-[#015354ff] lg:text-white"
                href="/register"
                size={"sm"}
                variant={"flat"}
              >
                Register
              </Button>
            </li>
            <li>{/* <ThemeSwitch /> */}</li>
          </ul>
        </div>
      </div>
    </header>
  );
}
